const AppRoutes = {
    profile_dashboard: "/user/dashboard",
    profile_orders: "/user/orders",
    profile_delivery_details: "/user/delivery_details",
    profile_saved_items: "/user/saved_items",
    // profile_dashboard: "/user/",
    signin: "/signin",
    signup: "/signup",
    forgot_password: "/forgot_password",
    privacy_policy: "/privacy_policy",
    //products
    tables: "/tables",
    shop: "/shop",
    checkout: "/checkout",
    cart: "/cart",
    sofa: "/sofa",
    product_detail: "/product_detail",
    story: "/story",
    faqs: "/faqs",
    blog: "/blog",
    returns_policy: "/returns_policy",
    portfolio: "/portfolio",
    media: "/media",
    contact_us: "/contact_us",
    assembly: "/assembly",
    terms: "/terms",
    accessibility: "/accessibility",
    sitemap: "/sitemap",
}

export default AppRoutes;